import React from 'react'

export default function ServiceCard(props) {
  return (
    <>
    <div className={`px-5 py-5 z-10 rounded-xl ${props.bgColor} text-center w-full md:w-[calc(100%/3-20px)] max-w-[320px]`}>
        <br />
        <img src={process.env.REACT_APP_PUBLIC_URL+props.image} className='max-w-[100px] mx-auto' alt={props.name} />
        <h6 className='text-xl font-semibold my-2 text-white'>{props.name}</h6>
        <p className='my-2 px-2 text-gray-100 text-sm'>{props.description}</p>
        <br />
        <a href="#learn" className='text-white font-bold'>{'Learn More >'}</a>
    </div>
    </>
  )
}
